if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector(".quantity__input");
        this.configuratorTrigger = this.querySelector("[data-configurator]");
        this.variantsData;
        this.updateMediaGrouping();

        // this.productTags = JSON.parse(this.dataset.tags);
        // if (this.dataset.discounts) {
        //     this.discounts = JSON.parse(this.dataset.discounts);
        // }
        if (this.configuratorTrigger) {
          this.productConfigurator = document.querySelector(
            'product-configurator[data-section="' +
              this.configuratorTrigger.dataset.configurator +
              '"]',
          );
          const params = new URL(document.location).searchParams;
          if (params.has("_configurator_design_id")) {
            this.productConfigurator.dispatchEvent(
              new CustomEvent("shirtup:render", { bubbles: true }),
            );
          }
        }

        if (this.configuratorTrigger && this.productConfigurator) {
          this.configuratorTrigger.addEventListener("click", (ev) => {
            ev.preventDefault();
            this.productConfigurator.dispatchEvent(
              new CustomEvent("shirtup:render", { bubbles: true }),
            );
          });
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        // Event delegation for iris-quantity-input changes (persists across variant re-renders)
        this.addEventListener("input", (event) => {
          const irisinput = event.target.closest("iris-quantity-input[data-size]");
          if (!irisinput) return;
          const qty = parseInt(event.target.value) || 0;
          irisinput.classList.toggle("has-value", qty > 0);
          this.sendPreselectedSizesOnly();
          this.updateSizeTotal();
        });

        // handlePrintTypeChange
        this.handlePrintTypeChange();
        this.addEventListener("change", () => {
          this.handlePrintTypeChange();
        });

        // Send initial sizes on load
        this.sendPreselectedSizesOnly();
        this.updateSizeTotal();

        // Additional initialization
        const variant = this.getSelectedVariant(document);

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );

        this.sizeVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            if (data.sectionId !== this.sectionId) return;

            // Update data-base-price with the new variant's price so
            // updateCalculation() uses the correct price immediately —
            // the Liquid-rendered value is only set once on page load.
            const calcEl = this.querySelector(`#size-calculation-${this.dataset.section}`);
            if (calcEl && data.variant?.price != null) {
              calcEl.dataset.basePrice = data.variant.price;
            }

            this.updateCalculation();
          },
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true }),
        );
      }

      handlePrintTypeChange() {
        const pdpTabsEl = document.querySelector("pdp-tabs");

        if (pdpTabsEl) {
          pdpTabsEl.dispatchEvent(new Event("trigger-technique-change", { bubbles: true }));                                                                                                             
        }

        // Scope to the active variant-selects — viewTransition keeps the old
        // one hidden in the DOM for 500ms with stale ids that no longer match
        // any label[for], which would resolve .colorEN:checked / .radio-btn:checked
        // to the wrong (old) elements during that window.
        const scope = this.querySelector("variant-selects") || this;

        let radioBtn = scope.querySelector(".radio-btn:checked");

        if (radioBtn) {
          let printTechniqueSelected = radioBtn.value;

          const event = new CustomEvent("shirtup:updatePrintTechnique", {
            bubbles: true,
            detail: {
              selectedTechnique: printTechniqueSelected,
            },
          });

          if (this.productConfigurator) {
            this.productConfigurator.dispatchEvent(event);
          } else {
            console.error("Product configurator not found.");
          }

          let colorPickerElement = scope.querySelector(".colorEN:checked");
          if (colorPickerElement) {
            let hideDtgButton = colorPickerElement.dataset.dtg;
            let inputPrintType = scope.querySelectorAll("input[data-print]");

            if (hideDtgButton == "true") {
              inputPrintType.forEach((input) => {
                const escapedId = CSS.escape(input.id);
                const label = scope.querySelector(`label[for="${escapedId}"]`);
                if (!label) return;

                if (input.dataset.print == "dtg") {
                  label.classList.add("label__disabled");
                  input.checked = false;
                } else {
                  label.classList.remove("label__disabled");
                  input.checked = true;
                }
              });
            } else {
              inputPrintType.forEach((input) => {
                const escapedId = CSS.escape(input.id);
                const label = scope.querySelector(`label[for="${escapedId}"]`);
                if (!label) return;

                label.classList.remove("label__disabled");
              });
            }
          }
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      logCartQuantitiesForAllVariants() {
        const cartItems = window.CartItems || []; // Replace with your actual cart items structure

        // cartItems.forEach((item) => {
        //   console.log(`Variant ID: ${item.variant_id}, Quantity in Cart: ${item.quantity}`);
        // });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.sizeVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel"),
            ),
        );
        // Preserve the user's print-method selection (printing-type.liquid) across
        // variant-selects re-renders — otherwise Liquid's default `checked` logic
        // resets it back to DTG/DTF based on product.type, discarding the user's choice.
        this.preProcessHtmlCallbacks.push((html) => {
          const checkedRadio = this.querySelector('input[name="print-method"]:checked');
          if (!checkedRadio) return;
          html.querySelectorAll('input[name="print-method"]').forEach((radio) => {
            radio.toggleAttribute("checked", radio.value === checkedRadio.value);
          });
        });
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;
        // Ignore quantity inputs — handled by delegated input listener
        if (event.target.closest("iris-quantity-input[data-size]")) return;
        // Ignore print-method radios (printing-type.liquid) — not a Shopify
        // variant option, handled separately by handlePrintTypeChange().
        if (event.target.name === "print-method") return;
        this.resetProductFormState();
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;

        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        const variantId = target.getAttribute("data-variant-id");
        let variantHidden = target.getAttribute("data-variant-hidden");
        if (variantHidden == null) {
          variantHidden = "false";
        }

        this.instantMediaUpdateByVariantId(variantId);

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            variantId,
            shouldFetchFullPage,
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl, variantHidden),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks,
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value

            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }
      getCheckedSizes() {
        const checkedValues = [];
        const scope = this.querySelector("variant-selects") || this;
        scope.querySelectorAll("iris-quantity-input[data-size]").forEach((irisinput) => {
          const input = irisinput.querySelector('input[slot="input"]');
          if (input && (parseInt(input.value) || 0) > 0) {
            checkedValues.push(irisinput.dataset.size);
          }
        });
        return checkedValues;
      }

      sendPreselectedSizesOnly() {
        const preselectedSizes = this.getCheckedSizes();
        const sizeQuantities = {};
        const scope = this.querySelector("variant-selects") || this;
        scope.querySelectorAll("iris-quantity-input[data-size]").forEach((irisinput) => {
          const input = irisinput.querySelector('input[slot="input"]');
          const qty = parseInt(input?.value) || 0;
          if (qty > 0) sizeQuantities[irisinput.dataset.size] = qty;
        });

        const event = new CustomEvent("shirtup:updateSizes", {
          bubbles: true,
          detail: { preselectedSizes, sizeQuantities },
        });

        if (this.productConfigurator) {
          this.productConfigurator.dispatchEvent(event);
        } else {
          console.error("Product configurator not found.");
        }
      }

      updateSizeTotal() {
        this.updateCalculation();
      }

      updateDiscountHint() {
        this.updateCalculation();
      }

      updateCalculation() {
        const calcEl = this.querySelector(`#size-calculation-${this.dataset.section}`);
        if (!calcEl) return;

        // Scope to the first (active) variant-selects only.
        // viewTransition keeps the old variant-selects hidden in the DOM for
        // 500 ms — without scoping, querySelectorAll would also pick up inputs
        // from the hidden old element and sum their stale values.
        const scope = this.querySelector("variant-selects") || this;

        // ── 1. Sum quantities ──────────────────────────────────────────────
        let total = 0;
        scope.querySelectorAll("iris-quantity-input[data-size]").forEach((irisinput) => {
          const input = irisinput.querySelector('input[slot="input"]');
          total += parseInt(input?.value) || 0;
        });

        // ── 2. Base price + money format ───────────────────────────────────
        const basePrice = parseInt(calcEl.dataset.basePrice) || 0;
        const moneyFormat = calcEl.dataset.moneyFormat || "{{ amount }}";
        const fmt = (cents) => Shopify.formatMoney(cents, moneyFormat);

        // ── 3. Discount breaks ──────────────────────────────────────────────
        // TAG-A (configurator) products: read from product-configurator element.
        // Discount1/plain products: no configurator present — read from the
        // calculation element itself (data-discounts/tags/percentage are set
        // in product-variant-picker.liquid using product_tag_discount_json logic).
        let discounts = [];
        let productTags = [];
        let startingPercentage = 0;
        const discountSource = this.productConfigurator || calcEl;
        try { discounts = JSON.parse(discountSource.dataset.discounts || "[]"); } catch (e) {}
        try {
          const rawTags = discountSource.dataset.tags || "";
          if (rawTags.trim().startsWith("[")) {
            productTags = JSON.parse(rawTags);
          } else {
            productTags = rawTags ? rawTags.split(",").map((t) => t.trim()).filter(Boolean) : [];
          }
        } catch (e) {}
        startingPercentage = parseFloat(discountSource.dataset.percentage) || 0;

        // Find the relevant discount group for this product's tags
        // (mirrors prepareDiscounts in global-1.js)
        let matchedGroup = null;
        let relevantBreaks = [];
        for (const group of discounts) {
          if (productTags.includes(group.tag)) {
            matchedGroup = group;
            // Strictly greater: the startingPercentage level is covered by the
            // synthetic break below, so tiers here only show what's above it.
            relevantBreaks = group.breaks.filter((b) => b.percentage > startingPercentage);
            if (startingPercentage !== 0) {
              relevantBreaks = [{ quantity: 1, percentage: startingPercentage }, ...relevantBreaks];
            }
            break;
          }
        }

        // Discount1-type products: startingPercentage > 0 but no group in discounts_json
        // matches the product tag. Synthesise a single base break so the starting
        // discount is always applied (same as price.liquid which always shows the
        // discounted price for Discount1 products).
        if (!matchedGroup && startingPercentage > 0) {
          relevantBreaks = [{ quantity: 1, percentage: startingPercentage }];
        }

        // Active break: highest break whose quantity <= total
        // Next break: lowest break whose quantity > total
        const reachedBreaks   = relevantBreaks.filter((b) => b.quantity <= total);
        const unreachedBreaks = relevantBreaks.filter((b) => b.quantity > total);
        const currentBreak = reachedBreaks.length
          ? reachedBreaks.reduce((prev, curr) => (curr.quantity > prev.quantity ? curr : prev))
          : null;
        const nextBreak = unreachedBreaks.length
          ? unreachedBreaks.reduce((prev, curr) => (curr.quantity < prev.quantity ? curr : prev))
          : null;

        // For Discount1 products: always apply at least startingPercentage
        // (mirrors price.liquid which always shows the discounted price).
        const currentPercentage = currentBreak ? currentBreak.percentage : startingPercentage;
        const currentPrice = Math.round(basePrice - basePrice * (currentPercentage / 100));
        const hasDiscount = currentPercentage > 0;

        // ── 4. Items selected counter ──────────────────────────────────────
        const totalEl = this.querySelector(`#size-total-${this.dataset.section}`);
        if (totalEl) {
          const countEl = totalEl.querySelector(".size-total-count");
          if (countEl) countEl.textContent = total;
        }

        // ── 5. Price per item ──────────────────────────────────────────────
        const priceCurrentEl  = this.querySelector(`#price-per-item-${this.dataset.section}`);
        const priceOriginalEl = this.querySelector(`#price-original-${this.dataset.section}`);
        if (priceCurrentEl) priceCurrentEl.textContent = fmt(currentPrice);
        if (priceOriginalEl) {
          priceOriginalEl.textContent = fmt(basePrice);
          priceOriginalEl.classList.toggle("hidden", !hasDiscount);
        }

        // ── 6. Discount row (active badge + next tier hint) ─────────────────
        // Text from window.discountStrings (theme.liquid, Shopify t filter = multilang)
        // messageOne / messageOther = same keys used by configurator pricingRequested()
        // messageDiscount = active discount badge text
        const discountRow      = this.querySelector(`#discount-row-${this.dataset.section}`);
        const activeDiscountEl = this.querySelector(`#active-discount-${this.dataset.section}`);
        const hintEl           = this.querySelector(`#discount-hint-${this.dataset.section}`);

        if (activeDiscountEl) {
          if (hasDiscount) {
            const textEl = activeDiscountEl.querySelector(".size-selector__active-discount-text");
            if (textEl) {
              const activeText = (window.discountStrings?.messageDiscount || "[discount]")
                .replace("[discount]", currentPercentage + "%");
              textEl.innerHTML = activeText;
            }
            activeDiscountEl.classList.remove("hidden");
          } else {
            activeDiscountEl.classList.add("hidden");
          }
        }

        if (hintEl) {
          if (nextBreak) {
            const needed = nextBreak.quantity - total;
            // Same pattern as configurator pricingRequested() in global-1.js
            let hintText = needed === 1
              ? (window.discountStrings?.messageOne || "Add 1 more for [discount]").replace("1", needed)
              : (window.discountStrings?.messageOther || "Add 2 more for [discount]").replace("2", needed);
            hintText = hintText.replace("[discount]", nextBreak.percentage + "%");
            hintEl.textContent = hintText;
            hintEl.classList.remove("hidden");
          } else {
            hintEl.textContent = "";
            hintEl.classList.add("hidden");
          }
        }

        if (discountRow) {
          discountRow.classList.toggle("hidden", !hasDiscount && !nextBreak);
        }

        // ── 7. Subtotal ────────────────────────────────────────────────────
        const subtotalEl = this.querySelector(`#size-subtotal-${this.dataset.section}`);
        if (subtotalEl) {
          if (total > 0) {
            const subtotalCurrent  = total * currentPrice;
            const subtotalOriginal = total * basePrice;
            const valueEl = subtotalEl.querySelector(".size-selector__subtotal-current");
            const origEl  = subtotalEl.querySelector(".size-selector__subtotal-original");
            if (valueEl) valueEl.textContent = fmt(subtotalCurrent);
            if (origEl) {
              origEl.textContent = fmt(subtotalOriginal);
              origEl.classList.toggle("hidden", !hasDiscount);
            }
            subtotalEl.classList.remove("hidden");
          } else {
            subtotalEl.classList.add("hidden");
          }
        }
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]",
        )?.innerHTML;

        const variantsColor = JSON.parse(selectedVariant);
        const color = variantsColor.option1;
        const size = [variantsColor.option2];

        const variants = this.getVariantData().filter(
          (v) => color == v["option1"] && v["available"] == true,
        );
        const event = new CustomEvent("shirtup:update", {
          bubbles: true,
          detail: {
            color: color,
            variants: variants,
            //preselectedVariants: size,
          },
        });
        if (this.configuratorTrigger) {
          this.productConfigurator.dispatchEvent(event);
        }
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false,
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`variant=${optionValues}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks,
          );
          // Re-apply the color-based DTG disable state to the freshly-swapped
          // variant-selects — the fetched HTML has no `label__disabled` class
          // yet, so without this it only appears once the user clicks a radio.
          this.handlePrintTypeChange();
        }
      }

      handleUpdateProductInfo(productUrl, variantHidden) {
        return (html) => {
          const variant = this.getSelectedVariant(html);          
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          const startDesignButton = this.querySelector(".g-btn__pdp");
          if (variantHidden == "false") {
            startDesignButton.removeAttribute("disabled");
          } else {
            startDesignButton.setAttribute("disabled", "disabled");
          }

          if (!variant) {
            this.setUnavailable();
            return;
          }

          // this.updateMedia(html, variant?.featured_media?.id);
          this.updateMediaGrouping();

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false,
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`,
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden"),
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === "",
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden"),
          );

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`,
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`,
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
            html
              .getElementById(`ProductSubmitButton-${this.sectionId}`)
              ?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
          );
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`,
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable,
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      instantMediaUpdateByVariantId(variantId) {
        if (!variantId) return;
      
        const variant = this.getVariantData().find(
          (item) => String(item.id) === String(variantId)
        );
      
        if (!variant?.featured_media?.id) return;
      
        const mediaGallery = this.querySelector("media-gallery");
        if (!mediaGallery) return;
      
        const targetMediaItem = mediaGallery.querySelector(
          `.product__media-item[data-media-id$="-${variant.featured_media.id}"]`
        );
      
        if (!targetMediaItem) return;
      
        const targetMediaId = targetMediaItem.dataset.mediaId;
        const targetGrouping = targetMediaItem.getAttribute("data-variant-grouping");
      
        mediaGallery
          .querySelectorAll(".product__media-item, .thumbnail-list__item")
          .forEach((item) => {
            if (item.hasAttribute("data-metafield-featured")) return;
      
            const itemGrouping = item.getAttribute("data-variant-grouping");
      
            if (!targetGrouping || itemGrouping === targetGrouping) {
              item.classList.remove("hide-image");
            } else {
              item.classList.add("hide-image");
            }
          });
      
        mediaGallery.setActiveMedia?.(targetMediaId, true);
      
        mediaGallery
          .querySelectorAll(".thumbnail[aria-current='true']")
          .forEach((btn) => btn.removeAttribute("aria-current"));
      
        const targetThumbnailButton = mediaGallery.querySelector(
          `.thumbnail-list__item[data-target="${targetMediaId}"] .thumbnail`
        );
      
        if (targetThumbnailButton) {
          targetThumbnailButton.setAttribute("aria-current", "true");
        }
      
        mediaGallery.querySelectorAll("slider-component").forEach((slider) => {
          if (typeof slider.resetPages === "function") {
            slider.resetPages();
          }
        });
      }

      updateMediaGrouping() {
        const mediaGalleries = this.querySelectorAll("media-gallery");
        mediaGalleries.forEach((mediaGallery) => {
          const groupVariants = mediaGallery.getAttribute(
            "data-group-variants",
          );
          const hasOnlyDefaultVariant = mediaGallery.getAttribute(
            "data-has-only-default-variant",
          );
          const disableImageGrouping = mediaGallery.getAttribute(
            "data-disable-image-grouping",
          );

          if (
            groupVariants === "false" ||
            hasOnlyDefaultVariant === "true" ||
            disableImageGrouping === "true"
          ) {
            return;
          }

          const mediaItemsAll = mediaGallery.querySelectorAll(
            ".product__media-item, .thumbnail-list__item",
          );
          const mediaItems = Array.from(mediaItemsAll).filter(
            (media) => !media.hasAttribute("data-metafield-featured"),
          );
          const featuredMedia = mediaItems.find(
            (media) => !media.classList.contains("hide-image"),
          );
          const featuredVariantGrouping = featuredMedia
            ? featuredMedia.getAttribute("data-variant-grouping")
            : null;

          mediaItems.forEach((mediaItem) => {
            const mediaVariantGrouping = mediaItem.getAttribute(
              "data-variant-grouping",
            );
            if (mediaVariantGrouping === featuredVariantGrouping) {
              mediaItem.classList.remove("hide-image");
            } else {
              mediaItem.classList.add("hide-image");
            }
          });

          const modalContent = this.productModal?.querySelector(
            ".product-media-modal__content",
          );
          if (modalContent) {
            modalContent
              .querySelectorAll(".product-modal-image")
              .forEach((mediaItem) => {
                const mediaVariantGrouping = mediaItem.getAttribute(
                  "data-variant-grouping",
                );
                mediaItem.classList.toggle(
                  "hide-image",
                  mediaVariantGrouping !== featuredVariantGrouping,
                );
              });
          }
        });
      }


      // updateMediaGrouping() {
      //   const mediaGalleries = this.querySelectorAll('media-gallery');
      //   console.log({mediaGalleries})

      //   mediaGalleries.forEach(mediaGallery => {
      //     console.log({mediaGallery})

      //     const groupVariants = mediaGallery.getAttribute('data-group-variants');
      //     console.log('groupvar', groupVariants)
      //     const hasOnlyDefaultVariant = mediaGallery.getAttribute('data-has-only-default-variant');
      //     const disableImageGrouping = mediaGallery.getAttribute('data-disable-image-grouping');

      //     if (groupVariants === 'false' || hasOnlyDefaultVariant === 'true' || disableImageGrouping === 'true') {
      //       return;
      //     }

      //     const mediaItems = mediaGallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
      //     const featuredMedia = Array.from(mediaItems).find(media => !media.classList.contains('hide-image'));

      //     console.log('featuredMedia', featuredMedia)
      //     const featuredVariantGrouping = featuredMedia ? featuredMedia.getAttribute('data-variant-grouping') : null;
      //     console.log('mediaItems', mediaItems.length)

      //     console.log('featuredVariantGrouping', featuredVariantGrouping)

      //     mediaItems.forEach(mediaItem => {
      //       const mediaVariantGrouping = mediaItem.getAttribute('data-variant-grouping');
      //       console.log('mediaVarGr',mediaVariantGrouping)
      //       if (mediaVariantGrouping == featuredVariantGrouping) {
      //         mediaItem.classList.remove('hide-image');
      //       } else {
      //         mediaItem.classList.add('hide-image');
      //       }
      //     });

      //     const modalContent = this.productModal?.querySelector('.product-media-modal__content');
      //     if (modalContent) {
      //       modalContent.querySelectorAll('.product-modal-image').forEach(mediaItem => {
      //         const mediaVariantGrouping = mediaItem.getAttribute('data-variant-grouping');
      //         mediaItem.classList.toggle('hide-image', mediaVariantGrouping !== featuredVariantGrouping);
      //       });
      //     }
      //   });
      // }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]"),
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId),
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ]),
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]"),
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId),
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`,
                  ),
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            },
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true,
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`,
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`,
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        this.fetchCart()
          .then((cartData) => {
            let totalCartQuantity = 0;
            const currentProductId = this.dataset.productId;

            // Filter and sum up quantities for items with the same product ID
            cartData.items.forEach((item) => {
              if (item.product_id === parseInt(currentProductId, 10)) {
                totalCartQuantity += item.quantity;
              }
            });

            window.totalCartQuantity = parseInt(totalCartQuantity || 0);
          })
          .catch((error) => {
            console.error("Error fetching cart:", error);
          });

        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchCart() {
        return fetch("/cart.js")
          .then((response) => response.json())
          .then((cartData) => cartData)
          .catch((error) => {
            console.error("Error fetching cart:", error);
            throw error;
          });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector(
          ".quantity__rules-cart .loading__spinner",
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() =>
            this.querySelector(
              ".quantity__rules-cart .loading__spinner",
            ).classList.add("hidden"),
          );
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`,
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      getVariantData() {
        this.variantsData = JSON.parse(
          this.querySelector("#allVariants").textContent,
        );
        return this.variantsData;
      }
      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list",
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`,
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    },
  );
}
if (!customElements.get('discount-table-modal')) {
  customElements.define('discount-table-modal', class DiscountTableModal extends HTMLElement {
    connectedCallback() {
      this.discountEl = this.querySelector('.pdp-tab__discount');
      if (!this.discountEl) return;

      // The variant_picker block has no column settings, so the columns render empty.
      // Clone the fully-rendered column HTML from the pdp-tabs section on this page.
      const source = document.querySelector('pdp-tabs .pdp-tab__discount');
      if (source) {
        const sourceCols = source.querySelectorAll(':scope > .pdp-tab__discount-column');
        const modalCols  = this.discountEl.querySelectorAll(':scope > .pdp-tab__discount-column');
        sourceCols.forEach((col, i) => {
          if (modalCols[i]) modalCols[i].innerHTML = col.innerHTML;
        });
      }

      this.tableValues = this.querySelector('.pdp-tab__table-values');
      this.dtfBlock    = this.querySelector('.pdp-tab__dtf-charges');
      this.dtgBlock    = this.querySelector('.pdp-tab__dtg-charges');

      // Hide the price column header — modal shows quantity + % only
      const headlineCols = this.querySelectorAll('.pdp-tab__table-headlines .pdp-tab__table-column-headline');
      if (headlineCols[1]) headlineCols[1].style.display = 'none';

      this.render();

      document.addEventListener('trigger-technique-change', () => this.render());
    }

    render() {
      if (!this.tableValues) return;

      const rawDiscounts = this.discountEl.dataset.discount;
      const productTags  = this.discountEl.dataset.tags || '';
      const percentage   = parseInt(this.discountEl.dataset.percentage) || 0;
      const technique    = document.querySelector('.radio-btn:checked')?.value;

      // Show/hide DTF vs DTG printing charge blocks
      if (technique === 'DTG') {
        if (this.dtgBlock) this.dtgBlock.style.display = 'block';
        if (this.dtfBlock) this.dtfBlock.style.display = 'none';
      } else if (technique === 'DTF') {
        if (this.dtgBlock) this.dtgBlock.style.display = 'none';
        if (this.dtfBlock) this.dtfBlock.style.display = 'block';
      }

      // Build discount tier rows (quantity range + % only — no price per item)
      let discounts;
      try { discounts = JSON.parse(rawDiscounts); } catch (e) { return; }

      let group;
      discounts.forEach(g => {
        if (productTags.includes(g.tag)) {
          let breaks = g.breaks.filter(b => b.percentage > percentage);
          if (percentage !== 0 && (!breaks.length || breaks[0].percentage !== percentage)) {
            breaks.unshift({ quantity: 1, percentage });
          }
          group = { ...g, breaks };
        }
      });
      if (!group) return;

      const tiers = group.breaks.map((b, i, arr) => {
        const next = arr[i + 1]?.quantity;
        return { range: next ? `${b.quantity}-${next - 1}` : `${b.quantity}+`, percentage: b.percentage };
      });

      this.tableValues.innerHTML = '';
      tiers.forEach((tier, i) => {
        const row = document.createElement('div');
        row.className = `pdp-tab__table-row body-small${i % 2 === 1 ? ' pdp-tab__table-highlighted' : ''}`;

        const qtySpan = document.createElement('span');
        qtySpan.textContent = tier.range;

        const pctSpan = document.createElement('span');
        pctSpan.className = 'pdp-tab__table-column3 pdp-tab__table-attention';
        pctSpan.textContent = `${tier.percentage}%`;

        row.appendChild(qtySpan);
        row.appendChild(pctSpan);
        this.tableValues.appendChild(row);
      });
    }
  });
}